/* eslint-disable eqeqeq */
import {connect} from "react-redux";
import { getCustomize,handleColorBackgroundChange } from "../../redux/actions/actions.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const Profile_Customize_BackgroundColor_Button = (props) => {

    const handleClick = (color) => {
        props.onColorBackgroundChange(color,props.user.id);
    }
    const circle = document.getElementsByClassName(`profile_customize_section_background_button_circle_${props.color}`)[0];
    const handleMouseOver = () => {
        circle.classList.add(`profile_customize_section_background_button_circle_shadow_${props.color}`);
    }
    const handleMouseOut = () => {
        circle.classList.remove(`profile_customize_section_background_button_circle_shadow_${props.color}`);
    }
    return (props.color == props.color_background) ?
        (
            <button onClick={()=>handleClick(props.color)} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} className={`profile_customize_section_background_button profile_customize_section_background_button_chosen_${props.color_button} profile_customize_section_background_button_${props.color}`}>
                <div className={`profile_customize_section_background_button_circle_chosen customizecolorchange_${props.color_button} profile_customize_section_background_button_circle_${props.color}`}>
                    <FontAwesomeIcon className="profile_customize_section_color_background_tick" icon={faCheck}  />
                </div>
                <div className={`profile_customize_section_background_button_text profile_customize_section_background_button_text_${props.color}`}>{props.color}</div>
            </button>
        ):
        (
            <button onClick={()=>handleClick(props.color)} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} className={`profile_customize_section_background_button profile_customize_section_background_button_unchosen profile_customize_section_background_button_${props.color}`}>
                <div className={`profile_customize_section_background_button_circle profile_customize_section_background_button_circle_${props.color}`}></div>
                <div className={`profile_customize_section_background_button_text profile_customize_section_background_button_text_${props.color}`}>{props.color}</div>
            </button>
        )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetCustomize: (id) => dispatch(getCustomize(id)),
        onColorBackgroundChange: (color,i) => dispatch(handleColorBackgroundChange(color,i))  
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Profile_Customize_BackgroundColor_Button);